import RmLoadingDots from 'Base/shared/rm/components/page-components/rm-loading-dots/rm-loading-dots';

const pageComponents = () => {
    customElements.define('rm-loading-dots', RmLoadingDots);
};

pageComponents();
